module.exports = __webpack_public_path__ + "static/media/picture-(33).6e1c7514.JPG";